import { Building2, Users, Lightbulb } from 'lucide-react';
import Container from '../ui/Container';
import SectionHeading from '../ui/SectionHeading';

const benefits = [
  {
    icon: Building2,
    title: "Impactful Projects",
    description: "Work on transformative projects across Tourism, Energy, Finance, Consultancy, Media, Construction and more."
  },
  {
    icon: Users,
    title: "Collaborative Environment",
    description: "Join a team of passionate and driven professionals dedicated to excellence."
  },
  {
    icon: Lightbulb,
    title: "Drive Change",
    description: "Contribute to sustainable development and empowerment across Ghana and the continent."
  }
];

export default function WhyJoinUs() {
  return (
    <section className="py-16">
      <Container>
        <SectionHeading
          title="Why Work With Us?"
          subtitle="Are you the best at what you do, or do you strive to become the best? At BNC Africa Holdings, we set audacious goals and hold ourselves to the highest standards."
          centered
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <Icon className="w-12 h-12 text-brown-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
}